module.exports = __webpack_public_path__ + "img/发展历程.d5a41587.svg";